import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import HSNCodeList from './HSNCode/HSNCodeList'
import { useDispatch, useSelector } from 'react-redux'
import AssignTaxRateList from './AssignTaxRate/AssignTaxRateList'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

const HSNCode = () => {
  const { pageAccess } = useSelector((state) => state.user)

  const [activeToggle, setActiveToggle] = useState(
    checkPageAccess(pageAccess, allPages?.hsnCode, allCrudNames?.read)
      ? 'HSNCodeList'
      : checkPageAccess(
          pageAccess,
          allPages?.assignTaxRateToHSN,
          allCrudNames?.read
        )
      ? 'AssignTaxRateList'
      : ''
  )

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return checkPageAccess(
    pageAccess,
    [allPages?.hsnCode, allPages?.assignTaxRateToHSN],
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.hsnCode,
              allCrudNames?.read
            ) && (
              <Link
                onClick={(e) => handleTabClick(e, 'HSNCodeList')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'HSNCodeList' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  HSN Code
                  <hr />
                </span>
              </Link>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.assignTaxRateToHSN,
              allCrudNames?.read
            ) && (
              <Link
                onClick={(e) => handleTabClick(e, 'AssignTaxRateList')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'AssignTaxRateList' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Assign Tax Rate to HSN Code
                  <hr />
                </span>
              </Link>
            )}
          </div>

          <div className='tab-content p-3'>
            {checkPageAccess(
              pageAccess,
              allPages?.hsnCode,
              allCrudNames?.read
            ) && (
              <div
                id='maincategory'
                className={`tab-pane fade ${
                  activeToggle === 'HSNCodeList' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'HSNCodeList' && <HSNCodeList />}
              </div>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.assignTaxRateToHSN,
              allCrudNames?.read
            ) && (
              <div
                id='AssignTaxRateList'
                className={`tab-pane fade ${
                  activeToggle === 'AssignTaxRateList' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'AssignTaxRateList' && <AssignTaxRateList />}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default HSNCode
